export const GET_LIST_MOVIE_MANAGEMENT = "GET_LIST_MOVIE_MANAGEMENT"
export const GET_MOVIE_DATE_MANAGEMENT = "GET_MOVIE_DATE_MANAGEMENT"
export const DELETE_LIST_MOVIE_MANAGEMENT = "DELETE_LIST_MOVIE_MANAGEMENT"

// edit
export const INFO_MOVIE_MANAGEMENT = "INFO_MOVIE_MANAGEMENT"
export const PAGE_FORM_MOVIE_MANAGEMENT = "PAGE_FORM_MOVIE_MANAGEMENT"

// creat schedule
export const GET_MAPHIM_MOVIE_MANAGEMENT = "GET_MAPHIM_MOVIE_MANAGEMENT"
export const GET_CODE_CINEMA_MOVIE_MANAGEMENT = "GET_CODE_CINEMA_MOVIE_MANAGEMENT"
export const GET_CUM_RAP_MOVIE_MANAGEMENT = "GET_CUM_RAP_MOVIE_MANAGEMENT"